/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";

import { loginUser, dismissMessage } from "../../reduxStore/actions/auth";

import PublicLayout from "../../containers/Layout/PublicLayout";
import LoginForm from "../../containers/LoginForm";

import LogoImg from "../../assets/images/group-3@3x.png";

import Label from "../../components/label";
import Anchor from "../../components/anchor";
import APP_CONSTANTS from "../../constants";
import appRoutes from "../../routes/appRoutes";

import deviceCheck from "../../utils/checkDevice";
import Model from "../../components/modal";

class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: false,
      browserNotCompatable: false,
      browserNotCompatablePopUp: false
    };
  }

  onLoginFormSubmit = formValues => {
    this.props.loginUser({
      email: formValues.email,
      password: formValues.password,
      deviceType: 2,
      deviceToken: "a3032435-e665-4118-aaca-7aec9531c96e"
      // deviceToken: this.props.userSubscribed && this.props.userSubscribed.oneSignalSubscribed && this.props.userSubscribed.oneSignalSubscribed.oneSignalId ? this.props.userSubscribed.oneSignalSubscribed.oneSignalId : ""
    });
    if (this.props.auth.error) {
      setTimeout(() => {
        this.props.dismissMessage();
      }, 3000);
    }
  };

  componentDidMount() {
    let browser = deviceCheck();
    if (browser.mobile) {
      this.setState({
        mobile: true,
        browserNotCompatable: true,
        browserNotCompatablePopUp: true
      });
    } else {
      this.setState({
        mobile: false,
        browserNotCompatable: false,
        browserNotCompatablePopUp: false
      });
    }
    if (
      browser.name === "chrome" &&
        // || browser.name === "safari") && // For now we are not supporting safari browser
      browser.mobile &&
      browser.mobile !== true
    ) {
      this.setState({
        browserNotCompatable: true,
        browserNotCompatablePopUp: true
      });
    }

    // if (browser.desktop && browser.name === "chrome" || browser.name === "safari") {
    // if ((browser.desktop && (browser.name === "chrome") || (browser.ipad && browser.name === "webkit"))) {
    if ((browser.desktop && (browser.name === "chrome") || (browser.ipad && (browser.name === "webkit" || browser.name === "safari")))) {
      this.setState({
        browserNotCompatable: false,
        browserNotCompatablePopUp: false
      });
    } else {
      this.setState({
        browserNotCompatable: true,
        browserNotCompatablePopUp: true
      });
    }

    try{
      if (/Edge/.test(navigator.userAgent) || /Edg/.test(navigator.userAgent)) {
        this.setState({
          browserNotCompatable: true,
          browserNotCompatablePopUp: true
        });
      }
      if (/edge/.test(navigator.userAgent) || /edg/.test(navigator.userAgent)) {
        this.setState({
          browserNotCompatable: true,
          browserNotCompatablePopUp: true
        });
      }
    }catch(e){
      console.log("Something went wrong when checking browser user agent!");
    }

    if (browser.ipad) {
      this.setState({
        mobile: false,
        browserNotCompatable: false,
        browserNotCompatablePopUp: false
      });
    }

    try {
      let isBrave = navigator.brave.isBrave();
      if(isBrave) {
        this.setState({
          browserNotCompatable: true,
          browserNotCompatablePopUp: true
        });
      }
    }
    catch(err) {
      console.log("Something went wrong when checking browser user agent!");
    }

    try {
      localStorage.clear();
    } catch (err) {
      console.log("Try to clear localstorage : ", err);
    }
  }

  closeBrowserDetectionModel = () => {
    this.setState({ browserNotCompatablePopUp: false });
  };

  render() {
    return (
      <PublicLayout>
        <div className="login-page-container container d-flex align-items-center justify-content-center mb-5">
          <div className="lg-page-inner-container pb-4 pl-0 pr-0">
            <div className="lp-header ">
              <div className="col-md-12">Doctor Login</div>
            </div>
            <div className="row lp-content-container d-flex justify-content-center align-items-center">
              <div className="col-md-12 logo-img-container d-flex justify-content-center align-items-center">
                <img src={LogoImg} alt="logo-img" />
              </div>
              <div className="col-md-12 d-flex justify-content-center align-items-center lg-form-container">
                <LoginForm
                  onFormSubmit={this.onLoginFormSubmit}
                  serverErrorMsg={this.props.auth.message}
                  mobile={this.state.mobile}
                  browserNotCompatable={this.state.browserNotCompatable}
                />
              </div>
            </div>
            <div className="text-center pb-2">
              <Label title="Don't have an account?" className="font-14 gray" />
              <NavLink
                to={this.state.browserNotCompatable ? '' : appRoutes.signUp}
                className="insta-link-orange font-15 text-decoration-none"
                href="#"
                disabled={this.state.browserNotCompatable}
              >
                <span className="ml-2 pt-1">Sign Up</span>
              </NavLink>
            </div>
            <div className="text-center w-100 p-0 lg-as-doctor">
              <Anchor
                title="Login as Patient"
                className="text-white font-15"
                href={APP_CONSTANTS.patientURL}
              />
            </div>
          </div>
        </div>
        <Model
          openModal={this.state.browserNotCompatablePopUp}
          modalBodyContent={"Your web browser is not compatible.<br>We recommend using Google Chrome.<br>Please call Instant Consult Support on <br>1300 003 310 if you require any assistance."}
          okayText="Okay"
          cancelText="Okay"
          title="Instant Consult"
          useOneButton={true}
          okayEvent={this.closeBrowserDetectionModel}
          cancelEvent={this.closeBrowserDetectionModel}
        />
      </PublicLayout>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
  // userSubscribed: state.commonReducers // this is for one signal
});

const mapDispatchToProps = dispatch => ({
  loginUser: data => dispatch(loginUser(data)),
  dismissMessage: () => dispatch(dismissMessage())
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
